/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 49);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var O = 'object';
    var check = function (it) {
        return it && it.Math == Math && it;
      };
      
      // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
      module.exports =
        // eslint-disable-next-line no-undef
        check(typeof globalThis == O && globalThis) ||
        check(typeof window == O && window) ||
        check(typeof self == O && self) ||
        check(typeof global == O && global) ||
        // eslint-disable-next-line no-new-func
        Function('return this')();
      
      /* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))
      
      /***/ }),
      /* 1 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var global = __webpack_require__(0);
      var shared = __webpack_require__(24);
      var uid = __webpack_require__(33);
      var NATIVE_SYMBOL = __webpack_require__(65);
      
      var Symbol = global.Symbol;
      var store = shared('wks');
      
      module.exports = function (name) {
        return store[name] || (store[name] = NATIVE_SYMBOL && Symbol[name]
          || (NATIVE_SYMBOL ? Symbol : uid)('Symbol.' + name));
      };
      
      
      /***/ }),
      /* 2 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var DESCRIPTORS = __webpack_require__(8);
      var definePropertyModule = __webpack_require__(14);
      var createPropertyDescriptor = __webpack_require__(15);
      
      module.exports = DESCRIPTORS ? function (object, key, value) {
        return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
      } : function (object, key, value) {
        object[key] = value;
        return object;
      };
      
      
      /***/ }),
      /* 3 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var isObject = __webpack_require__(5);
      
      module.exports = function (it) {
        if (!isObject(it)) {
          throw TypeError(String(it) + ' is not an object');
        } return it;
      };
      
      
      /***/ }),
      /* 4 */
      /***/ (function(module, exports) {
      
      module.exports = function (exec) {
        try {
          return !!exec();
        } catch (error) {
          return true;
        }
      };
      
      
      /***/ }),
      /* 5 */
      /***/ (function(module, exports) {
      
      module.exports = function (it) {
        return typeof it === 'object' ? it !== null : typeof it === 'function';
      };
      
      
      /***/ }),
      /* 6 */
      /***/ (function(module, exports) {
      
      var hasOwnProperty = {}.hasOwnProperty;
      
      module.exports = function (it, key) {
        return hasOwnProperty.call(it, key);
      };
      
      
      /***/ }),
      /* 7 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var global = __webpack_require__(0);
      var getOwnPropertyDescriptor = __webpack_require__(35).f;
      var isForced = __webpack_require__(36);
      var path = __webpack_require__(18);
      var bind = __webpack_require__(28);
      var hide = __webpack_require__(2);
      var has = __webpack_require__(6);
      
      var wrapConstructor = function (NativeConstructor) {
        var Wrapper = function (a, b, c) {
          if (this instanceof NativeConstructor) {
            switch (arguments.length) {
              case 0: return new NativeConstructor();
              case 1: return new NativeConstructor(a);
              case 2: return new NativeConstructor(a, b);
            } return new NativeConstructor(a, b, c);
          } return NativeConstructor.apply(this, arguments);
        };
        Wrapper.prototype = NativeConstructor.prototype;
        return Wrapper;
      };
      
      /*
        options.target      - name of the target object
        options.global      - target is the global object
        options.stat        - export as static methods of target
        options.proto       - export as prototype methods of target
        options.real        - real prototype method for the `pure` version
        options.forced      - export even if the native feature is available
        options.bind        - bind methods to the target, required for the `pure` version
        options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
        options.unsafe      - use the simple assignment of property instead of delete + defineProperty
        options.sham        - add a flag to not completely full polyfills
        options.enumerable  - export as enumerable property
        options.noTargetGet - prevent calling a getter on target
      */
      module.exports = function (options, source) {
        var TARGET = options.target;
        var GLOBAL = options.global;
        var STATIC = options.stat;
        var PROTO = options.proto;
      
        var nativeSource = GLOBAL ? global : STATIC ? global[TARGET] : (global[TARGET] || {}).prototype;
      
        var target = GLOBAL ? path : path[TARGET] || (path[TARGET] = {});
        var targetPrototype = target.prototype;
      
        var FORCED, USE_NATIVE, VIRTUAL_PROTOTYPE;
        var key, sourceProperty, targetProperty, nativeProperty, resultProperty, descriptor;
      
        for (key in source) {
          FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
          // contains in native
          USE_NATIVE = !FORCED && nativeSource && has(nativeSource, key);
      
          targetProperty = target[key];
      
          if (USE_NATIVE) if (options.noTargetGet) {
            descriptor = getOwnPropertyDescriptor(nativeSource, key);
            nativeProperty = descriptor && descriptor.value;
          } else nativeProperty = nativeSource[key];
      
          // export native or implementation
          sourceProperty = (USE_NATIVE && nativeProperty) ? nativeProperty : source[key];
      
          if (USE_NATIVE && typeof targetProperty === typeof sourceProperty) continue;
      
          // bind timers to global for call from export context
          if (options.bind && USE_NATIVE) resultProperty = bind(sourceProperty, global);
          // wrap global constructors for prevent changs in this version
          else if (options.wrap && USE_NATIVE) resultProperty = wrapConstructor(sourceProperty);
          // make static versions for prototype methods
          else if (PROTO && typeof sourceProperty == 'function') resultProperty = bind(Function.call, sourceProperty);
          // default case
          else resultProperty = sourceProperty;
      
          // add a flag to not completely full polyfills
          if (options.sham || (sourceProperty && sourceProperty.sham) || (targetProperty && targetProperty.sham)) {
            hide(resultProperty, 'sham', true);
          }
      
          target[key] = resultProperty;
      
          if (PROTO) {
            VIRTUAL_PROTOTYPE = TARGET + 'Prototype';
            if (!has(path, VIRTUAL_PROTOTYPE)) hide(path, VIRTUAL_PROTOTYPE, {});
            // export virtual prototype methods
            path[VIRTUAL_PROTOTYPE][key] = sourceProperty;
            // export real prototype methods
            if (options.real && targetPrototype && !targetPrototype[key]) hide(targetPrototype, key, sourceProperty);
          }
        }
      };
      
      
      /***/ }),
      /* 8 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var fails = __webpack_require__(4);
      
      // Thank's IE8 for his funny defineProperty
      module.exports = !fails(function () {
        return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
      });
      
      
      /***/ }),
      /* 9 */
      /***/ (function(module, exports) {
      
      module.exports = function (it) {
        if (typeof it != 'function') {
          throw TypeError(String(it) + ' is not a function');
        } return it;
      };
      
      
      /***/ }),
      /* 10 */
      /***/ (function(module, exports) {
      
      module.exports = {};
      
      
      /***/ }),
      /* 11 */
      /***/ (function(module, exports) {
      
      var toString = {}.toString;
      
      module.exports = function (it) {
        return toString.call(it).slice(8, -1);
      };
      
      
      /***/ }),
      /* 12 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var path = __webpack_require__(18);
      var global = __webpack_require__(0);
      
      var aFunction = function (variable) {
        return typeof variable == 'function' ? variable : undefined;
      };
      
      module.exports = function (namespace, method) {
        return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
          : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
      };
      
      
      /***/ }),
      /* 13 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var aFunction = __webpack_require__(9);
      
      var PromiseCapability = function (C) {
        var resolve, reject;
        this.promise = new C(function ($$resolve, $$reject) {
          if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
          resolve = $$resolve;
          reject = $$reject;
        });
        this.resolve = aFunction(resolve);
        this.reject = aFunction(reject);
      };
      
      // 25.4.1.5 NewPromiseCapability(C)
      module.exports.f = function (C) {
        return new PromiseCapability(C);
      };
      
      
      /***/ }),
      /* 14 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var DESCRIPTORS = __webpack_require__(8);
      var IE8_DOM_DEFINE = __webpack_require__(31);
      var anObject = __webpack_require__(3);
      var toPrimitive = __webpack_require__(32);
      
      var nativeDefineProperty = Object.defineProperty;
      
      // `Object.defineProperty` method
      // https://tc39.github.io/ecma262/#sec-object.defineproperty
      exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
        anObject(O);
        P = toPrimitive(P, true);
        anObject(Attributes);
        if (IE8_DOM_DEFINE) try {
          return nativeDefineProperty(O, P, Attributes);
        } catch (error) { /* empty */ }
        if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
        if ('value' in Attributes) O[P] = Attributes.value;
        return O;
      };
      
      
      /***/ }),
      /* 15 */
      /***/ (function(module, exports) {
      
      module.exports = function (bitmap, value) {
        return {
          enumerable: !(bitmap & 1),
          configurable: !(bitmap & 2),
          writable: !(bitmap & 4),
          value: value
        };
      };
      
      
      /***/ }),
      /* 16 */
      /***/ (function(module, exports) {
      
      module.exports = true;
      
      
      /***/ }),
      /* 17 */
      /***/ (function(module, exports, __webpack_require__) {
      
      // toObject with fallback for non-array-like ES3 strings
      var IndexedObject = __webpack_require__(61);
      var requireObjectCoercible = __webpack_require__(22);
      
      module.exports = function (it) {
        return IndexedObject(requireObjectCoercible(it));
      };
      
      
      /***/ }),
      /* 18 */
      /***/ (function(module, exports) {
      
      module.exports = {};
      
      
      /***/ }),
      /* 19 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var anObject = __webpack_require__(3);
      var isArrayIteratorMethod = __webpack_require__(81);
      var toLength = __webpack_require__(39);
      var bind = __webpack_require__(28);
      var getIteratorMethod = __webpack_require__(82);
      var callWithSafeIterationClosing = __webpack_require__(83);
      
      var Result = function (stopped, result) {
        this.stopped = stopped;
        this.result = result;
      };
      
      var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
        var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
        var iterator, iterFn, index, length, result, step;
      
        if (IS_ITERATOR) {
          iterator = iterable;
        } else {
          iterFn = getIteratorMethod(iterable);
          if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
          // optimisation for array iterators
          if (isArrayIteratorMethod(iterFn)) {
            for (index = 0, length = toLength(iterable.length); length > index; index++) {
              result = AS_ENTRIES
                ? boundFunction(anObject(step = iterable[index])[0], step[1])
                : boundFunction(iterable[index]);
              if (result && result instanceof Result) return result;
            } return new Result(false);
          }
          iterator = iterFn.call(iterable);
        }
      
        while (!(step = iterator.next()).done) {
          result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
          if (result && result instanceof Result) return result;
        } return new Result(false);
      };
      
      iterate.stop = function (result) {
        return new Result(true, result);
      };
      
      
      /***/ }),
      /* 20 */
      /***/ (function(module, exports) {
      
      module.exports = function (exec) {
        try {
          return { error: false, value: exec() };
        } catch (error) {
          return { error: true, value: error };
        }
      };
      
      
      /***/ }),
      /* 21 */
      /***/ (function(module, exports) {
      
      var ceil = Math.ceil;
      var floor = Math.floor;
      
      // `ToInteger` abstract operation
      // https://tc39.github.io/ecma262/#sec-tointeger
      module.exports = function (argument) {
        return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
      };
      
      
      /***/ }),
      /* 22 */
      /***/ (function(module, exports) {
      
      // `RequireObjectCoercible` abstract operation
      // https://tc39.github.io/ecma262/#sec-requireobjectcoercible
      module.exports = function (it) {
        if (it == undefined) throw TypeError("Can't call method on " + it);
        return it;
      };
      
      
      /***/ }),
      /* 23 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var NATIVE_WEAK_MAP = __webpack_require__(56);
      var global = __webpack_require__(0);
      var isObject = __webpack_require__(5);
      var hide = __webpack_require__(2);
      var objectHas = __webpack_require__(6);
      var sharedKey = __webpack_require__(26);
      var hiddenKeys = __webpack_require__(27);
      
      var WeakMap = global.WeakMap;
      var set, get, has;
      
      var enforce = function (it) {
        return has(it) ? get(it) : set(it, {});
      };
      
      var getterFor = function (TYPE) {
        return function (it) {
          var state;
          if (!isObject(it) || (state = get(it)).type !== TYPE) {
            throw TypeError('Incompatible receiver, ' + TYPE + ' required');
          } return state;
        };
      };
      
      if (NATIVE_WEAK_MAP) {
        var store = new WeakMap();
        var wmget = store.get;
        var wmhas = store.has;
        var wmset = store.set;
        set = function (it, metadata) {
          wmset.call(store, it, metadata);
          return metadata;
        };
        get = function (it) {
          return wmget.call(store, it) || {};
        };
        has = function (it) {
          return wmhas.call(store, it);
        };
      } else {
        var STATE = sharedKey('state');
        hiddenKeys[STATE] = true;
        set = function (it, metadata) {
          hide(it, STATE, metadata);
          return metadata;
        };
        get = function (it) {
          return objectHas(it, STATE) ? it[STATE] : {};
        };
        has = function (it) {
          return objectHas(it, STATE);
        };
      }
      
      module.exports = {
        set: set,
        get: get,
        has: has,
        enforce: enforce,
        getterFor: getterFor
      };
      
      
      /***/ }),
      /* 24 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var global = __webpack_require__(0);
      var setGlobal = __webpack_require__(59);
      var IS_PURE = __webpack_require__(16);
      
      var SHARED = '__core-js_shared__';
      var store = global[SHARED] || setGlobal(SHARED, {});
      
      (module.exports = function (key, value) {
        return store[key] || (store[key] = value !== undefined ? value : {});
      })('versions', []).push({
        version: '3.1.3',
        mode: IS_PURE ? 'pure' : 'global',
        copyright: 'Â© 2019 Denis Pushkarev (zloirock.ru)'
      });
      
      
      /***/ }),
      /* 25 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var global = __webpack_require__(0);
      var isObject = __webpack_require__(5);
      
      var document = global.document;
      // typeof document.createElement is 'object' in old IE
      var EXISTS = isObject(document) && isObject(document.createElement);
      
      module.exports = function (it) {
        return EXISTS ? document.createElement(it) : {};
      };
      
      
      /***/ }),
      /* 26 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var shared = __webpack_require__(24);
      var uid = __webpack_require__(33);
      
      var keys = shared('keys');
      
      module.exports = function (key) {
        return keys[key] || (keys[key] = uid(key));
      };
      
      
      /***/ }),
      /* 27 */
      /***/ (function(module, exports) {
      
      module.exports = {};
      
      
      /***/ }),
      /* 28 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var aFunction = __webpack_require__(9);
      
      // optional / simple context binding
      module.exports = function (fn, that, length) {
        aFunction(fn);
        if (that === undefined) return fn;
        switch (length) {
          case 0: return function () {
            return fn.call(that);
          };
          case 1: return function (a) {
            return fn.call(that, a);
          };
          case 2: return function (a, b) {
            return fn.call(that, a, b);
          };
          case 3: return function (a, b, c) {
            return fn.call(that, a, b, c);
          };
        }
        return function (/* ...args */) {
          return fn.apply(that, arguments);
        };
      };
      
      
      /***/ }),
      /* 29 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var has = __webpack_require__(6);
      var toObject = __webpack_require__(63);
      var sharedKey = __webpack_require__(26);
      var CORRECT_PROTOTYPE_GETTER = __webpack_require__(64);
      
      var IE_PROTO = sharedKey('IE_PROTO');
      var ObjectPrototype = Object.prototype;
      
      // `Object.getPrototypeOf` method
      // https://tc39.github.io/ecma262/#sec-object.getprototypeof
      module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
        O = toObject(O);
        if (has(O, IE_PROTO)) return O[IE_PROTO];
        if (typeof O.constructor == 'function' && O instanceof O.constructor) {
          return O.constructor.prototype;
        } return O instanceof Object ? ObjectPrototype : null;
      };
      
      
      /***/ }),
      /* 30 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var defineProperty = __webpack_require__(14).f;
      var hide = __webpack_require__(2);
      var has = __webpack_require__(6);
      var toString = __webpack_require__(71);
      var wellKnownSymbol = __webpack_require__(1);
      
      var TO_STRING_TAG = wellKnownSymbol('toStringTag');
      var METHOD_REQUIRED = toString !== ({}).toString;
      
      module.exports = function (it, TAG, STATIC, SET_METHOD) {
        if (it) {
          var target = STATIC ? it : it.prototype;
          if (!has(target, TO_STRING_TAG)) {
            defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
          }
          if (SET_METHOD && METHOD_REQUIRED) hide(target, 'toString', toString);
        }
      };
      
      
      /***/ }),
      /* 31 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var DESCRIPTORS = __webpack_require__(8);
      var fails = __webpack_require__(4);
      var createElement = __webpack_require__(25);
      
      // Thank's IE8 for his funny defineProperty
      module.exports = !DESCRIPTORS && !fails(function () {
        return Object.defineProperty(createElement('div'), 'a', {
          get: function () { return 7; }
        }).a != 7;
      });
      
      
      /***/ }),
      /* 32 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var isObject = __webpack_require__(5);
      
      // `ToPrimitive` abstract operation
      // https://tc39.github.io/ecma262/#sec-toprimitive
      // instead of the ES6 spec version, we didn't implement @@toPrimitive case
      // and the second argument - flag - preferred type is a string
      module.exports = function (input, PREFERRED_STRING) {
        if (!isObject(input)) return input;
        var fn, val;
        if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
        if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
        if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
        throw TypeError("Can't convert object to primitive value");
      };
      
      
      /***/ }),
      /* 33 */
      /***/ (function(module, exports) {
      
      var id = 0;
      var postfix = Math.random();
      
      module.exports = function (key) {
        return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
      };
      
      
      /***/ }),
      /* 34 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var $ = __webpack_require__(7);
      var createIteratorConstructor = __webpack_require__(62);
      var getPrototypeOf = __webpack_require__(29);
      var setPrototypeOf = __webpack_require__(43);
      var setToStringTag = __webpack_require__(30);
      var hide = __webpack_require__(2);
      var redefine = __webpack_require__(44);
      var wellKnownSymbol = __webpack_require__(1);
      var IS_PURE = __webpack_require__(16);
      var Iterators = __webpack_require__(10);
      var IteratorsCore = __webpack_require__(37);
      
      var IteratorPrototype = IteratorsCore.IteratorPrototype;
      var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
      var ITERATOR = wellKnownSymbol('iterator');
      var KEYS = 'keys';
      var VALUES = 'values';
      var ENTRIES = 'entries';
      
      var returnThis = function () { return this; };
      
      module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
        createIteratorConstructor(IteratorConstructor, NAME, next);
      
        var getIterationMethod = function (KIND) {
          if (KIND === DEFAULT && defaultIterator) return defaultIterator;
          if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
          switch (KIND) {
            case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
            case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
            case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
          } return function () { return new IteratorConstructor(this); };
        };
      
        var TO_STRING_TAG = NAME + ' Iterator';
        var INCORRECT_VALUES_NAME = false;
        var IterablePrototype = Iterable.prototype;
        var nativeIterator = IterablePrototype[ITERATOR]
          || IterablePrototype['@@iterator']
          || DEFAULT && IterablePrototype[DEFAULT];
        var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
        var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
        var CurrentIteratorPrototype, methods, KEY;
      
        // fix native
        if (anyNativeIterator) {
          CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
          if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
              if (setPrototypeOf) {
                setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
              } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
                hide(CurrentIteratorPrototype, ITERATOR, returnThis);
              }
            }
            // Set @@toStringTag to native iterators
            setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
          }
        }
      
        // fix Array#{values, @@iterator}.name in V8 / FF
        if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
          INCORRECT_VALUES_NAME = true;
          defaultIterator = function values() { return nativeIterator.call(this); };
        }
      
        // define iterator
        if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
          hide(IterablePrototype, ITERATOR, defaultIterator);
        }
        Iterators[NAME] = defaultIterator;
      
        // export additional methods
        if (DEFAULT) {
          methods = {
            values: getIterationMethod(VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
            entries: getIterationMethod(ENTRIES)
          };
          if (FORCED) for (KEY in methods) {
            if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
              redefine(IterablePrototype, KEY, methods[KEY]);
            }
          } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
        }
      
        return methods;
      };
      
      
      /***/ }),
      /* 35 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var DESCRIPTORS = __webpack_require__(8);
      var propertyIsEnumerableModule = __webpack_require__(60);
      var createPropertyDescriptor = __webpack_require__(15);
      var toIndexedObject = __webpack_require__(17);
      var toPrimitive = __webpack_require__(32);
      var has = __webpack_require__(6);
      var IE8_DOM_DEFINE = __webpack_require__(31);
      
      var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      
      // `Object.getOwnPropertyDescriptor` method
      // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
      exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
        O = toIndexedObject(O);
        P = toPrimitive(P, true);
        if (IE8_DOM_DEFINE) try {
          return nativeGetOwnPropertyDescriptor(O, P);
        } catch (error) { /* empty */ }
        if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
      };
      
      
      /***/ }),
      /* 36 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var fails = __webpack_require__(4);
      
      var replacement = /#|\.prototype\./;
      
      var isForced = function (feature, detection) {
        var value = data[normalize(feature)];
        return value == POLYFILL ? true
          : value == NATIVE ? false
          : typeof detection == 'function' ? fails(detection)
          : !!detection;
      };
      
      var normalize = isForced.normalize = function (string) {
        return String(string).replace(replacement, '.').toLowerCase();
      };
      
      var data = isForced.data = {};
      var NATIVE = isForced.NATIVE = 'N';
      var POLYFILL = isForced.POLYFILL = 'P';
      
      module.exports = isForced;
      
      
      /***/ }),
      /* 37 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var getPrototypeOf = __webpack_require__(29);
      var hide = __webpack_require__(2);
      var has = __webpack_require__(6);
      var wellKnownSymbol = __webpack_require__(1);
      var IS_PURE = __webpack_require__(16);
      
      var ITERATOR = wellKnownSymbol('iterator');
      var BUGGY_SAFARI_ITERATORS = false;
      
      var returnThis = function () { return this; };
      
      // `%IteratorPrototype%` object
      // https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
      var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;
      
      if ([].keys) {
        arrayIterator = [].keys();
        // Safari 8 has buggy iterators w/o `next`
        if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
        else {
          PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
          if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
        }
      }
      
      if (IteratorPrototype == undefined) IteratorPrototype = {};
      
      // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
      if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
      
      module.exports = {
        IteratorPrototype: IteratorPrototype,
        BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
      };
      
      
      /***/ }),
      /* 38 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var anObject = __webpack_require__(3);
      var defineProperties = __webpack_require__(66);
      var enumBugKeys = __webpack_require__(40);
      var hiddenKeys = __webpack_require__(27);
      var html = __webpack_require__(41);
      var documentCreateElement = __webpack_require__(25);
      var sharedKey = __webpack_require__(26);
      var IE_PROTO = sharedKey('IE_PROTO');
      
      var PROTOTYPE = 'prototype';
      var Empty = function () { /* empty */ };
      
      // Create object with fake `null` prototype: use iframe Object with cleared prototype
      var createDict = function () {
        // Thrash, waste and sodomy: IE GC bug
        var iframe = documentCreateElement('iframe');
        var length = enumBugKeys.length;
        var lt = '<';
        var script = 'script';
        var gt = '>';
        var js = 'java' + script + ':';
        var iframeDocument;
        iframe.style.display = 'none';
        html.appendChild(iframe);
        iframe.src = String(js);
        iframeDocument = iframe.contentWindow.document;
        iframeDocument.open();
        iframeDocument.write(lt + script + gt + 'document.F=Object' + lt + '/' + script + gt);
        iframeDocument.close();
        createDict = iframeDocument.F;
        while (length--) delete createDict[PROTOTYPE][enumBugKeys[length]];
        return createDict();
      };
      
      // `Object.create` method
      // https://tc39.github.io/ecma262/#sec-object.create
      module.exports = Object.create || function create(O, Properties) {
        var result;
        if (O !== null) {
          Empty[PROTOTYPE] = anObject(O);
          result = new Empty();
          Empty[PROTOTYPE] = null;
          // add "__proto__" for Object.getPrototypeOf polyfill
          result[IE_PROTO] = O;
        } else result = createDict();
        return Properties === undefined ? result : defineProperties(result, Properties);
      };
      
      hiddenKeys[IE_PROTO] = true;
      
      
      /***/ }),
      /* 39 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var toInteger = __webpack_require__(21);
      
      var min = Math.min;
      
      // `ToLength` abstract operation
      // https://tc39.github.io/ecma262/#sec-tolength
      module.exports = function (argument) {
        return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
      };
      
      
      /***/ }),
      /* 40 */
      /***/ (function(module, exports) {
      
      // IE8- don't enum bug keys
      module.exports = [
        'constructor',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'toLocaleString',
        'toString',
        'valueOf'
      ];
      
      
      /***/ }),
      /* 41 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var getBuiltIn = __webpack_require__(12);
      
      module.exports = getBuiltIn('document', 'documentElement');
      
      
      /***/ }),
      /* 42 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var classofRaw = __webpack_require__(11);
      var wellKnownSymbol = __webpack_require__(1);
      
      var TO_STRING_TAG = wellKnownSymbol('toStringTag');
      // ES3 wrong here
      var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';
      
      // fallback for IE11 Script Access Denied error
      var tryGet = function (it, key) {
        try {
          return it[key];
        } catch (error) { /* empty */ }
      };
      
      // getting tag from ES6+ `Object.prototype.toString`
      module.exports = function (it) {
        var O, tag, result;
        return it === undefined ? 'Undefined' : it === null ? 'Null'
          // @@toStringTag case
          : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
          // builtinTag case
          : CORRECT_ARGUMENTS ? classofRaw(O)
          // ES3 arguments fallback
          : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
      };
      
      
      /***/ }),
      /* 43 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var anObject = __webpack_require__(3);
      var aPossiblePrototype = __webpack_require__(72);
      
      // `Object.setPrototypeOf` method
      // https://tc39.github.io/ecma262/#sec-object.setprototypeof
      // Works with __proto__ only. Old v8 can't work with null proto objects.
      /* eslint-disable no-proto */
      module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
        var CORRECT_SETTER = false;
        var test = {};
        var setter;
        try {
          setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
          setter.call(test, []);
          CORRECT_SETTER = test instanceof Array;
        } catch (error) { /* empty */ }
        return function setPrototypeOf(O, proto) {
          anObject(O);
          aPossiblePrototype(proto);
          if (CORRECT_SETTER) setter.call(O, proto);
          else O.__proto__ = proto;
          return O;
        };
      }() : undefined);
      
      
      /***/ }),
      /* 44 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var hide = __webpack_require__(2);
      
      module.exports = function (target, key, value, options) {
        if (options && options.enumerable) target[key] = value;
        else hide(target, key, value);
      };
      
      
      /***/ }),
      /* 45 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var anObject = __webpack_require__(3);
      var aFunction = __webpack_require__(9);
      var wellKnownSymbol = __webpack_require__(1);
      
      var SPECIES = wellKnownSymbol('species');
      
      // `SpeciesConstructor` abstract operation
      // https://tc39.github.io/ecma262/#sec-speciesconstructor
      module.exports = function (O, defaultConstructor) {
        var C = anObject(O).constructor;
        var S;
        return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
      };
      
      
      /***/ }),
      /* 46 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var global = __webpack_require__(0);
      var fails = __webpack_require__(4);
      var classof = __webpack_require__(11);
      var bind = __webpack_require__(28);
      var html = __webpack_require__(41);
      var createElement = __webpack_require__(25);
      
      var location = global.location;
      var set = global.setImmediate;
      var clear = global.clearImmediate;
      var process = global.process;
      var MessageChannel = global.MessageChannel;
      var Dispatch = global.Dispatch;
      var counter = 0;
      var queue = {};
      var ONREADYSTATECHANGE = 'onreadystatechange';
      var defer, channel, port;
      
      var run = function (id) {
        // eslint-disable-next-line no-prototype-builtins
        if (queue.hasOwnProperty(id)) {
          var fn = queue[id];
          delete queue[id];
          fn();
        }
      };
      
      var runner = function (id) {
        return function () {
          run(id);
        };
      };
      
      var listener = function (event) {
        run(event.data);
      };
      
      var post = function (id) {
        // old engines have not location.origin
        global.postMessage(id + '', location.protocol + '//' + location.host);
      };
      
      // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
      if (!set || !clear) {
        set = function setImmediate(fn) {
          var args = [];
          var i = 1;
          while (arguments.length > i) args.push(arguments[i++]);
          queue[++counter] = function () {
            // eslint-disable-next-line no-new-func
            (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
          };
          defer(counter);
          return counter;
        };
        clear = function clearImmediate(id) {
          delete queue[id];
        };
        // Node.js 0.8-
        if (classof(process) == 'process') {
          defer = function (id) {
            process.nextTick(runner(id));
          };
        // Sphere (JS game engine) Dispatch API
        } else if (Dispatch && Dispatch.now) {
          defer = function (id) {
            Dispatch.now(runner(id));
          };
        // Browsers with MessageChannel, includes WebWorkers
        } else if (MessageChannel) {
          channel = new MessageChannel();
          port = channel.port2;
          channel.port1.onmessage = listener;
          defer = bind(port.postMessage, port, 1);
        // Browsers with postMessage, skip WebWorkers
        // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
        } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts && !fails(post)) {
          defer = post;
          global.addEventListener('message', listener, false);
        // IE8-
        } else if (ONREADYSTATECHANGE in createElement('script')) {
          defer = function (id) {
            html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
              html.removeChild(this);
              run(id);
            };
          };
        // Rest old browsers
        } else {
          defer = function (id) {
            setTimeout(runner(id), 0);
          };
        }
      }
      
      module.exports = {
        set: set,
        clear: clear
      };
      
      
      /***/ }),
      /* 47 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var getBuiltIn = __webpack_require__(12);
      
      module.exports = getBuiltIn('navigator', 'userAgent') || '';
      
      
      /***/ }),
      /* 48 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var anObject = __webpack_require__(3);
      var isObject = __webpack_require__(5);
      var newPromiseCapability = __webpack_require__(13);
      
      module.exports = function (C, x) {
        anObject(C);
        if (isObject(x) && x.constructor === C) return x;
        var promiseCapability = newPromiseCapability.f(C);
        var resolve = promiseCapability.resolve;
        resolve(x);
        return promiseCapability.promise;
      };
      
      
      /***/ }),
      /* 49 */
      /***/ (function(module, exports, __webpack_require__) {
      
      const {setupStorage, setupStorageClient} = __webpack_require__(50);
      
      window.setupStorageClient = setupStorageClient;
      window.setupStorage = setupStorage;
    
      
      /***/ }),
      /* 50 */
      /***/ (function(module, exports, __webpack_require__) {
      
      const Promise = __webpack_require__(51);
      
      //prefixes
      const EVENT_PREFIX = '_genesysEvt';
      
      //events
      const STORE = `${EVENT_PREFIX}:STORE`;
      const STORE_RESULT = `${EVENT_PREFIX}:STORE_RESULT`;
      const RETRIEVE = `${EVENT_PREFIX}:RETRIEVE`;
      const RETRIEVE_RESULT = `${EVENT_PREFIX}:RETRIEVE_RESULT`;
      const REMOVE = `${EVENT_PREFIX}:REMOVE`;
      const REMOVE_RESULT = `${EVENT_PREFIX}:REMOVE_RESULT`;
      const ORIGIN_REGEXP = /^(http|https):\/\/[^/]+/;
      const INIT = `${EVENT_PREFIX}:INIT`;
      
      function getStorageKey({origin, key}) {
          return `${key}`;
      }
      
      function setupStorage(data) {
          window.addEventListener('message', async (message) => {
              const {
                  origin, 
                  source, 
                  data
              } = message;
      
              const {
                  type, // the type of post message this is eg. retrieve, store, remove
                  crossDomainOrigin, // domain data set to access
                  accessors, // list of domains that can access and modify the data
                  key, // data key to act on
                  value, // value to store
                  ttl, // how long should the data persist (beta)
                  requestId // a unique id to identify the request
              } = data;
      
              if (type === STORE) {
                  try {
                      await store(origin, {source, accessors, ttl, key, value, requestId});
                  } catch (err) {
                      source.postMessage({
                          type: STORE_RESULT,
                          requestId, 
                          err: err.message,
                          success: false
                      }, origin);
                  }
              } else if (type === RETRIEVE) {
                  try {
                      await retrieve(origin, {crossDomainOrigin, source, key, requestId});
                  } catch (err) {
                      source.postMessage({
                          type: RETRIEVE_RESULT,
                          requestId,
                          err: err.message,
                          success: false
                      }, origin);
                  }
              } else if (type === REMOVE) {
                  try {
                      await remove(origin, {crossDomainOrigin, source, key, requestId});
                  } catch (err) {
                      source.postMessage({
                          type: REMOVE_RESULT,
                          requestId,
                          err: err.message,
                          success: false
                      }, origin);
                  }
              }
          });
      
          window.parent.postMessage({ 
              type: INIT,
              success: true,
              frameHref: window.location.href
          }, '*');
      
          async function store(origin, {source, accessors, ttl, key, value, requestId}) {
              if (typeof key !== 'string') {
                  throw new Error('key must be a string');
              }
              const storageKey = getStorageKey({origin, key});
      
              if (!(accessors instanceof Array)) {
                  accessors = [];
              }
      
              accessors = accessors.filter(accessor => {
                  return typeof accessor === 'string' ? accessor : undefined;
              });
      
              if (!(origin in accessors)) {
                  accessors.push(origin);
              }
      
              const expiresAt = ttl ? Date.now() + ttl : null;
      
              window.localStorage.setItem(storageKey, JSON.stringify({
                  accessors,
                  origin,
                  requestId,
                  expiresAt,
                  value
              }));
      
              source.postMessage({
                  type: STORE_RESULT,
                  requestId, 
                  expiresAt,
                  storageKey,
                  key,
                  success: true
              }, origin);
          }
      
          async function retrieve(origin, {crossDomainOrigin, source, key, requestId}) {
              const keyOrigin = crossDomainOrigin || origin;
              const storageKey = getStorageKey({
                  origin: keyOrigin, 
                  key
              });
              const data = window.localStorage.getItem(storageKey);
      
              if (!data) {
                  throw new Error(`${key} not found`);
              }
              const {accessors, expiresAt, value} = JSON.parse(data);
      
              const grantedOrigin = ensureAccess({accessors, origin, crossDomainOrigin});
              if (!grantedOrigin) { throw new Error(`${key} not found`); }
      
              if (expiresAt && Date.now() > expiresAt) {
                  window.localStorage.removeItem(storageKey);
                  throw new Error(`${key} not found`);
              }
      
              return source.postMessage({
                  success: true,
                  type: RETRIEVE_RESULT,
                  key,
                  value,
                  requestId
              }, grantedOrigin);
          }
      
          async function remove(origin, {crossDomainOrigin, source, key, requestId}) {
              const keyOrigin = crossDomainOrigin || origin;
              const storageKey = getStorageKey({
                  origin: keyOrigin, 
                  key
              });
              const data = JSON.parse(localStorage.getItem(storageKey));
      
              if (!data) {
                  throw new Error(`${key} not found`);
              }
              
              const {accessors} = data;
      
              const grantedOrigin = ensureAccess({accessors, origin, crossDomainOrigin});
              if (!grantedOrigin) { throw new Error(`grant: ${key} not found`); }
      
              window.localStorage.removeItem(storageKey);
              return source.postMessage({
                  type: REMOVE_RESULT,
                  success: true,
                  requestId
              }, grantedOrigin);
          }
      
          function ensureAccess({accessors, origin, crossDomainOrigin}) {
              for (let i = 0; i < accessors.length; i++) {
                  let accessor = accessors[i];
                  // compare accessor with crossDomainOrigin which TLD. If same, return the actual origin.
                  if (accessor === crossDomainOrigin) {
                      return origin;
                  }
              }
              return null;
          }
      }
      
      function setupStorageClient({frame, targetUrl}) {
          const eventRegistry = {};
      
          if (!(frame instanceof window.HTMLElement) && targetUrl) {
              //create an iframe with the targetUrl
              frame = document.createElement('iframe');
              frame.setAttribute('src', targetUrl);
              frame.setAttribute('width', 0);
              frame.setAttribute('height', 0);
              frame.setAttribute('style', 'display: none; border: 0;');
              frame.setAttribute('sandbox', 'allow-scripts allow-same-origin');
              const body = document.getElementsByTagName('body')[0];
              body && body.appendChild(frame);
          }
          const frameUrl = frame.getAttribute('src');
          const [frameOrigin] = frameUrl.match(ORIGIN_REGEXP);
      
          window.addEventListener('message', message => {
              const {origin, data, source} = message;
              const {type, success, value, requestId, err} = data;
      
              if (source !== frame.contentWindow)  { return; }
      
              if (type === STORE_RESULT) {
                  handleRequestResult({origin, success, err, requestId});
              }
      
              if (type === RETRIEVE_RESULT) {
                  handleRequestResult({origin, success, err, requestId, value});
              }
      
              if (type === REMOVE_RESULT) {
                  handleRequestResult({origin, success, err, requestId});
              }
      
              if (type === INIT) {
                  handleRequestResult({origin, success, err, requestId: INIT});
              }
          });
      
          let nextRequestId = 0;
          function getRequestId() { return nextRequestId++; }
      
          function getRegistryKey(origin, requestId) {
              return `${origin}:::${requestId}`;
          }
      
          function handleRequestResult({origin, success, requestId, err, value}){
              const registryKey = getRegistryKey(origin, requestId);
              const callback = eventRegistry[registryKey];
      
              delete eventRegistry[registryKey];
              callback && callback({success, err, value});
          }
      
          function waitForRequestResult(requestId) {
              return new Promise((resolve, reject) => {
                  const registryKey = getRegistryKey(frameOrigin, requestId);
      
                  eventRegistry[registryKey] = ({success, err, value}) => {
                      return success ? resolve(value) : reject(new Error(err));
                  };
              });
          }
      
          async function store ({accessors, ttl, key, value}){
              const requestId = getRequestId();
              const responsePromise = waitForRequestResult(requestId);
              frame.contentWindow.postMessage({
                  type: STORE,
                  key,
                  value,
                  accessors,
                  ttl,
                  requestId
              }, frameOrigin);
              return responsePromise;
          }
      
          async function remove({key, crossDomainOrigin}) {
              const targetOrigins = crossDomainOrigin ? crossDomainOrigin.split('|'): [undefined];
              let error;
              for(let targetOrigin of targetOrigins) {
                  try {
                      const remove = await _remove(key, targetOrigin);
                      return remove;
                  } catch (e) {
                      error = e;
                      continue;
                  }
              }
              throw error;
      
          }
      
          function _remove(key, targetOrigin) {
              const requestId = getRequestId();
              const responsePromise = waitForRequestResult(requestId);
              frame.contentWindow.postMessage({
                  type: REMOVE,
                  key,
                  requestId,
                  crossDomainOrigin: targetOrigin
              }, frameOrigin);
              return responsePromise;
          }
      
      
          async function retrieve({key, crossDomainOrigin}) {
              const targetOrigins = crossDomainOrigin ? crossDomainOrigin.split('|'): [undefined];
              let error;
              for(let targetOrigin of targetOrigins) {
                  try {
                      const retrieve = await _retrieve(key, targetOrigin);
                      return retrieve;
                  } catch (e) {
                      error = e;
                      continue;
                  }
              }
              throw error;
      
          }
      
          function _retrieve(key, targetOrigin) {
              const requestId = getRequestId();
              const responsePromise = waitForRequestResult(requestId);
              frame.contentWindow.postMessage({
                  type: RETRIEVE,
                  crossDomainOrigin: targetOrigin,
                  key,
                  requestId
              }, frameOrigin);
              return responsePromise;
          }
      
          async function init() {
              await waitForRequestResult(INIT);
              return this;
          }
      
          return {store, retrieve, remove, init};
      }
      
      module.exports = { setupStorage, setupStorageClient };
      
      
      /***/ }),
      /* 51 */
      /***/ (function(module, exports, __webpack_require__) {
      
      module.exports = __webpack_require__(52);
      
      __webpack_require__(88);
      __webpack_require__(89);
      __webpack_require__(90);
      __webpack_require__(91);
      
      
      /***/ }),
      /* 52 */
      /***/ (function(module, exports, __webpack_require__) {
      
      __webpack_require__(53);
      __webpack_require__(54);
      __webpack_require__(73);
      __webpack_require__(77);
      __webpack_require__(87);
      var path = __webpack_require__(18);
      
      module.exports = path.Promise;
      
      
      /***/ }),
      /* 53 */
      /***/ (function(module, exports) {
      
      // empty
      
      
      /***/ }),
      /* 54 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var charAt = __webpack_require__(55).charAt;
      var InternalStateModule = __webpack_require__(23);
      var defineIterator = __webpack_require__(34);
      
      var STRING_ITERATOR = 'String Iterator';
      var setInternalState = InternalStateModule.set;
      var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);
      
      // `String.prototype[@@iterator]` method
      // https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
      defineIterator(String, 'String', function (iterated) {
        setInternalState(this, {
          type: STRING_ITERATOR,
          string: String(iterated),
          index: 0
        });
      // `%StringIteratorPrototype%.next` method
      // https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
      }, function next() {
        var state = getInternalState(this);
        var string = state.string;
        var index = state.index;
        var point;
        if (index >= string.length) return { value: undefined, done: true };
        point = charAt(string, index);
        state.index += point.length;
        return { value: point, done: false };
      });
      
      
      /***/ }),
      /* 55 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var toInteger = __webpack_require__(21);
      var requireObjectCoercible = __webpack_require__(22);
      
      // `String.prototype.{ codePointAt, at }` methods implementation
      var createMethod = function (CONVERT_TO_STRING) {
        return function ($this, pos) {
          var S = String(requireObjectCoercible($this));
          var position = toInteger(pos);
          var size = S.length;
          var first, second;
          if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
          first = S.charCodeAt(position);
          return first < 0xD800 || first > 0xDBFF || position + 1 === size
            || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
              ? CONVERT_TO_STRING ? S.charAt(position) : first
              : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
        };
      };
      
      module.exports = {
        // `String.prototype.codePointAt` method
        // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
        codeAt: createMethod(false),
        // `String.prototype.at` method
        // https://github.com/mathiasbynens/String.prototype.at
        charAt: createMethod(true)
      };
      
      
      /***/ }),
      /* 56 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var global = __webpack_require__(0);
      var nativeFunctionToString = __webpack_require__(58);
      
      var WeakMap = global.WeakMap;
      
      module.exports = typeof WeakMap === 'function' && /native code/.test(nativeFunctionToString.call(WeakMap));
      
      
      /***/ }),
      /* 57 */
      /***/ (function(module, exports) {
      
      var g;
      
      // This works in non-strict mode
      g = (function() {
          return this;
      })();
      
      try {
          // This works if eval is allowed (see CSP)
          g = g || Function("return this")() || (1,eval)("this");
      } catch(e) {
          // This works if the window reference is available
          if(typeof window === "object")
              g = window;
      }
      
      // g can still be undefined, but nothing to do about it...
      // We return undefined, instead of nothing here, so it's
      // easier to handle this case. if(!global) { ...}
      
      module.exports = g;
      
      
      /***/ }),
      /* 58 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var shared = __webpack_require__(24);
      
      module.exports = shared('native-function-to-string', Function.toString);
      
      
      /***/ }),
      /* 59 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var global = __webpack_require__(0);
      var hide = __webpack_require__(2);
      
      module.exports = function (key, value) {
        try {
          hide(global, key, value);
        } catch (error) {
          global[key] = value;
        } return value;
      };
      
      
      /***/ }),
      /* 60 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
      var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
      
      // Nashorn ~ JDK8 bug
      var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);
      
      // `Object.prototype.propertyIsEnumerable` method implementation
      // https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
      exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
        var descriptor = getOwnPropertyDescriptor(this, V);
        return !!descriptor && descriptor.enumerable;
      } : nativePropertyIsEnumerable;
      
      
      /***/ }),
      /* 61 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var fails = __webpack_require__(4);
      var classof = __webpack_require__(11);
      
      var split = ''.split;
      
      // fallback for non-array-like ES3 and non-enumerable old V8 strings
      module.exports = fails(function () {
        // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
        // eslint-disable-next-line no-prototype-builtins
        return !Object('z').propertyIsEnumerable(0);
      }) ? function (it) {
        return classof(it) == 'String' ? split.call(it, '') : Object(it);
      } : Object;
      
      
      /***/ }),
      /* 62 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var IteratorPrototype = __webpack_require__(37).IteratorPrototype;
      var create = __webpack_require__(38);
      var createPropertyDescriptor = __webpack_require__(15);
      var setToStringTag = __webpack_require__(30);
      var Iterators = __webpack_require__(10);
      
      var returnThis = function () { return this; };
      
      module.exports = function (IteratorConstructor, NAME, next) {
        var TO_STRING_TAG = NAME + ' Iterator';
        IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
        setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
        Iterators[TO_STRING_TAG] = returnThis;
        return IteratorConstructor;
      };
      
      
      /***/ }),
      /* 63 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var requireObjectCoercible = __webpack_require__(22);
      
      // `ToObject` abstract operation
      // https://tc39.github.io/ecma262/#sec-toobject
      module.exports = function (argument) {
        return Object(requireObjectCoercible(argument));
      };
      
      
      /***/ }),
      /* 64 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var fails = __webpack_require__(4);
      
      module.exports = !fails(function () {
        function F() { /* empty */ }
        F.prototype.constructor = null;
        return Object.getPrototypeOf(new F()) !== F.prototype;
      });
      
      
      /***/ }),
      /* 65 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var fails = __webpack_require__(4);
      
      module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
        // Chrome 38 Symbol has incorrect toString conversion
        // eslint-disable-next-line no-undef
        return !String(Symbol());
      });
      
      
      /***/ }),
      /* 66 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var DESCRIPTORS = __webpack_require__(8);
      var definePropertyModule = __webpack_require__(14);
      var anObject = __webpack_require__(3);
      var objectKeys = __webpack_require__(67);
      
      // `Object.defineProperties` method
      // https://tc39.github.io/ecma262/#sec-object.defineproperties
      module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
        anObject(O);
        var keys = objectKeys(Properties);
        var length = keys.length;
        var index = 0;
        var key;
        while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
        return O;
      };
      
      
      /***/ }),
      /* 67 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var internalObjectKeys = __webpack_require__(68);
      var enumBugKeys = __webpack_require__(40);
      
      // `Object.keys` method
      // https://tc39.github.io/ecma262/#sec-object.keys
      module.exports = Object.keys || function keys(O) {
        return internalObjectKeys(O, enumBugKeys);
      };
      
      
      /***/ }),
      /* 68 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var has = __webpack_require__(6);
      var toIndexedObject = __webpack_require__(17);
      var indexOf = __webpack_require__(69).indexOf;
      var hiddenKeys = __webpack_require__(27);
      
      module.exports = function (object, names) {
        var O = toIndexedObject(object);
        var i = 0;
        var result = [];
        var key;
        for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
        // Don't enum bug & hidden keys
        while (names.length > i) if (has(O, key = names[i++])) {
          ~indexOf(result, key) || result.push(key);
        }
        return result;
      };
      
      
      /***/ }),
      /* 69 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var toIndexedObject = __webpack_require__(17);
      var toLength = __webpack_require__(39);
      var toAbsoluteIndex = __webpack_require__(70);
      
      // `Array.prototype.{ indexOf, includes }` methods implementation
      var createMethod = function (IS_INCLUDES) {
        return function ($this, el, fromIndex) {
          var O = toIndexedObject($this);
          var length = toLength(O.length);
          var index = toAbsoluteIndex(fromIndex, length);
          var value;
          // Array#includes uses SameValueZero equality algorithm
          // eslint-disable-next-line no-self-compare
          if (IS_INCLUDES && el != el) while (length > index) {
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
          // Array#indexOf ignores holes, Array#includes - not
          } else for (;length > index; index++) {
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
          } return !IS_INCLUDES && -1;
        };
      };
      
      module.exports = {
        // `Array.prototype.includes` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.includes
        includes: createMethod(true),
        // `Array.prototype.indexOf` method
        // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
        indexOf: createMethod(false)
      };
      
      
      /***/ }),
      /* 70 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var toInteger = __webpack_require__(21);
      
      var max = Math.max;
      var min = Math.min;
      
      // Helper for a popular repeating case of the spec:
      // Let integer be ? ToInteger(index).
      // If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).
      module.exports = function (index, length) {
        var integer = toInteger(index);
        return integer < 0 ? max(integer + length, 0) : min(integer, length);
      };
      
      
      /***/ }),
      /* 71 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var classof = __webpack_require__(42);
      var wellKnownSymbol = __webpack_require__(1);
      
      var TO_STRING_TAG = wellKnownSymbol('toStringTag');
      var test = {};
      
      test[TO_STRING_TAG] = 'z';
      
      // `Object.prototype.toString` method implementation
      // https://tc39.github.io/ecma262/#sec-object.prototype.tostring
      module.exports = String(test) !== '[object z]' ? function toString() {
        return '[object ' + classof(this) + ']';
      } : test.toString;
      
      
      /***/ }),
      /* 72 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var isObject = __webpack_require__(5);
      
      module.exports = function (it) {
        if (!isObject(it) && it !== null) {
          throw TypeError("Can't set " + String(it) + ' as a prototype');
        } return it;
      };
      
      
      /***/ }),
      /* 73 */
      /***/ (function(module, exports, __webpack_require__) {
      
      __webpack_require__(74);
      var DOMIterables = __webpack_require__(76);
      var global = __webpack_require__(0);
      var hide = __webpack_require__(2);
      var Iterators = __webpack_require__(10);
      var wellKnownSymbol = __webpack_require__(1);
      
      var TO_STRING_TAG = wellKnownSymbol('toStringTag');
      
      for (var COLLECTION_NAME in DOMIterables) {
        var Collection = global[COLLECTION_NAME];
        var CollectionPrototype = Collection && Collection.prototype;
        if (CollectionPrototype && !CollectionPrototype[TO_STRING_TAG]) {
          hide(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
        }
        Iterators[COLLECTION_NAME] = Iterators.Array;
      }
      
      
      /***/ }),
      /* 74 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var toIndexedObject = __webpack_require__(17);
      var addToUnscopables = __webpack_require__(75);
      var Iterators = __webpack_require__(10);
      var InternalStateModule = __webpack_require__(23);
      var defineIterator = __webpack_require__(34);
      
      var ARRAY_ITERATOR = 'Array Iterator';
      var setInternalState = InternalStateModule.set;
      var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);
      
      // `Array.prototype.entries` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.entries
      // `Array.prototype.keys` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.keys
      // `Array.prototype.values` method
      // https://tc39.github.io/ecma262/#sec-array.prototype.values
      // `Array.prototype[@@iterator]` method
      // https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
      // `CreateArrayIterator` internal method
      // https://tc39.github.io/ecma262/#sec-createarrayiterator
      module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
        setInternalState(this, {
          type: ARRAY_ITERATOR,
          target: toIndexedObject(iterated), // target
          index: 0,                          // next index
          kind: kind                         // kind
        });
      // `%ArrayIteratorPrototype%.next` method
      // https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
      }, function () {
        var state = getInternalState(this);
        var target = state.target;
        var kind = state.kind;
        var index = state.index++;
        if (!target || index >= target.length) {
          state.target = undefined;
          return { value: undefined, done: true };
        }
        if (kind == 'keys') return { value: index, done: false };
        if (kind == 'values') return { value: target[index], done: false };
        return { value: [index, target[index]], done: false };
      }, 'values');
      
      // argumentsList[@@iterator] is %ArrayProto_values%
      // https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
      // https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
      Iterators.Arguments = Iterators.Array;
      
      // https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
      addToUnscopables('keys');
      addToUnscopables('values');
      addToUnscopables('entries');
      
      
      /***/ }),
      /* 75 */
      /***/ (function(module, exports) {
      
      module.exports = function () { /* empty */ };
      
      
      /***/ }),
      /* 76 */
      /***/ (function(module, exports) {
      
      // iterable DOM collections
      // flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
      module.exports = {
        CSSRuleList: 0,
        CSSStyleDeclaration: 0,
        CSSValueList: 0,
        ClientRectList: 0,
        DOMRectList: 0,
        DOMStringList: 0,
        DOMTokenList: 1,
        DataTransferItemList: 0,
        FileList: 0,
        HTMLAllCollection: 0,
        HTMLCollection: 0,
        HTMLFormElement: 0,
        HTMLSelectElement: 0,
        MediaList: 0,
        MimeTypeArray: 0,
        NamedNodeMap: 0,
        NodeList: 1,
        PaintRequestList: 0,
        Plugin: 0,
        PluginArray: 0,
        SVGLengthList: 0,
        SVGNumberList: 0,
        SVGPathSegList: 0,
        SVGPointList: 0,
        SVGStringList: 0,
        SVGTransformList: 0,
        SourceBufferList: 0,
        StyleSheetList: 0,
        TextTrackCueList: 0,
        TextTrackList: 0,
        TouchList: 0
      };
      
      
      /***/ }),
      /* 77 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var $ = __webpack_require__(7);
      var IS_PURE = __webpack_require__(16);
      var global = __webpack_require__(0);
      var path = __webpack_require__(18);
      var redefineAll = __webpack_require__(78);
      var setToStringTag = __webpack_require__(30);
      var setSpecies = __webpack_require__(79);
      var isObject = __webpack_require__(5);
      var aFunction = __webpack_require__(9);
      var anInstance = __webpack_require__(80);
      var classof = __webpack_require__(11);
      var iterate = __webpack_require__(19);
      var checkCorrectnessOfIteration = __webpack_require__(84);
      var speciesConstructor = __webpack_require__(45);
      var task = __webpack_require__(46).set;
      var microtask = __webpack_require__(85);
      var promiseResolve = __webpack_require__(48);
      var hostReportErrors = __webpack_require__(86);
      var newPromiseCapabilityModule = __webpack_require__(13);
      var perform = __webpack_require__(20);
      var userAgent = __webpack_require__(47);
      var InternalStateModule = __webpack_require__(23);
      var isForced = __webpack_require__(36);
      var wellKnownSymbol = __webpack_require__(1);
      
      var SPECIES = wellKnownSymbol('species');
      var PROMISE = 'Promise';
      var getInternalState = InternalStateModule.get;
      var setInternalState = InternalStateModule.set;
      var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
      var PromiseConstructor = global[PROMISE];
      var TypeError = global.TypeError;
      var document = global.document;
      var process = global.process;
      var $fetch = global.fetch;
      var versions = process && process.versions;
      var v8 = versions && versions.v8 || '';
      var newPromiseCapability = newPromiseCapabilityModule.f;
      var newGenericPromiseCapability = newPromiseCapability;
      var IS_NODE = classof(process) == 'process';
      var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
      var UNHANDLED_REJECTION = 'unhandledrejection';
      var REJECTION_HANDLED = 'rejectionhandled';
      var PENDING = 0;
      var FULFILLED = 1;
      var REJECTED = 2;
      var HANDLED = 1;
      var UNHANDLED = 2;
      var Internal, OwnPromiseCapability, PromiseWrapper;
      
      var FORCED = isForced(PROMISE, function () {
        // correct subclassing with @@species support
        var promise = PromiseConstructor.resolve(1);
        var empty = function () { /* empty */ };
        var FakePromise = (promise.constructor = {})[SPECIES] = function (exec) {
          exec(empty, empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return !((IS_NODE || typeof PromiseRejectionEvent == 'function')
          && (!IS_PURE || promise['finally'])
          && promise.then(empty) instanceof FakePromise
          // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
          // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
          // we can't detect it synchronously, so just check versions
          && v8.indexOf('6.6') !== 0
          && userAgent.indexOf('Chrome/66') === -1);
      });
      
      var INCORRECT_ITERATION = FORCED || !checkCorrectnessOfIteration(function (iterable) {
        PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
      });
      
      // helpers
      var isThenable = function (it) {
        var then;
        return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
      };
      
      var notify = function (promise, state, isReject) {
        if (state.notified) return;
        state.notified = true;
        var chain = state.reactions;
        microtask(function () {
          var value = state.value;
          var ok = state.state == FULFILLED;
          var index = 0;
          // variable length - can't use forEach
          while (chain.length > index) {
            var reaction = chain[index++];
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
              if (handler) {
                if (!ok) {
                  if (state.rejection === UNHANDLED) onHandleUnhandled(promise, state);
                  state.rejection = HANDLED;
                }
                if (handler === true) result = value;
                else {
                  if (domain) domain.enter();
                  result = handler(value); // can throw
                  if (domain) {
                    domain.exit();
                    exited = true;
                  }
                }
                if (result === reaction.promise) {
                  reject(TypeError('Promise-chain cycle'));
                } else if (then = isThenable(result)) {
                  then.call(result, resolve, reject);
                } else resolve(result);
              } else reject(value);
            } catch (error) {
              if (domain && !exited) domain.exit();
              reject(error);
            }
          }
          state.reactions = [];
          state.notified = false;
          if (isReject && !state.rejection) onUnhandled(promise, state);
        });
      };
      
      var dispatchEvent = function (name, promise, reason) {
        var event, handler;
        if (DISPATCH_EVENT) {
          event = document.createEvent('Event');
          event.promise = promise;
          event.reason = reason;
          event.initEvent(name, false, true);
          global.dispatchEvent(event);
        } else event = { promise: promise, reason: reason };
        if (handler = global['on' + name]) handler(event);
        else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
      };
      
      var onUnhandled = function (promise, state) {
        task.call(global, function () {
          var value = state.value;
          var IS_UNHANDLED = isUnhandled(state);
          var result;
          if (IS_UNHANDLED) {
            result = perform(function () {
              if (IS_NODE) {
                process.emit('unhandledRejection', value, promise);
              } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
            if (result.error) throw result.value;
          }
        });
      };
      
      var isUnhandled = function (state) {
        return state.rejection !== HANDLED && !state.parent;
      };
      
      var onHandleUnhandled = function (promise, state) {
        task.call(global, function () {
          if (IS_NODE) {
            process.emit('rejectionHandled', promise);
          } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
        });
      };
      
      var bind = function (fn, promise, state, unwrap) {
        return function (value) {
          fn(promise, state, value, unwrap);
        };
      };
      
      var internalReject = function (promise, state, value, unwrap) {
        if (state.done) return;
        state.done = true;
        if (unwrap) state = unwrap;
        state.value = value;
        state.state = REJECTED;
        notify(promise, state, true);
      };
      
      var internalResolve = function (promise, state, value, unwrap) {
        if (state.done) return;
        state.done = true;
        if (unwrap) state = unwrap;
        try {
          if (promise === value) throw TypeError("Promise can't be resolved itself");
          var then = isThenable(value);
          if (then) {
            microtask(function () {
              var wrapper = { done: false };
              try {
                then.call(value,
                  bind(internalResolve, promise, wrapper, state),
                  bind(internalReject, promise, wrapper, state)
                );
              } catch (error) {
                internalReject(promise, wrapper, error, state);
              }
            });
          } else {
            state.value = value;
            state.state = FULFILLED;
            notify(promise, state, false);
          }
        } catch (error) {
          internalReject(promise, { done: false }, error, state);
        }
      };
      
      // constructor polyfill
      if (FORCED) {
        // 25.4.3.1 Promise(executor)
        PromiseConstructor = function Promise(executor) {
          anInstance(this, PromiseConstructor, PROMISE);
          aFunction(executor);
          Internal.call(this);
          var state = getInternalState(this);
          try {
            executor(bind(internalResolve, this, state), bind(internalReject, this, state));
          } catch (error) {
            internalReject(this, state, error);
          }
        };
        // eslint-disable-next-line no-unused-vars
        Internal = function Promise(executor) {
          setInternalState(this, {
            type: PROMISE,
            done: false,
            notified: false,
            parent: false,
            reactions: [],
            rejection: false,
            state: PENDING,
            value: undefined
          });
        };
        Internal.prototype = redefineAll(PromiseConstructor.prototype, {
          // `Promise.prototype.then` method
          // https://tc39.github.io/ecma262/#sec-promise.prototype.then
          then: function then(onFulfilled, onRejected) {
            var state = getInternalPromiseState(this);
            var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
            reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
            reaction.fail = typeof onRejected == 'function' && onRejected;
            reaction.domain = IS_NODE ? process.domain : undefined;
            state.parent = true;
            state.reactions.push(reaction);
            if (state.state != PENDING) notify(this, state, false);
            return reaction.promise;
          },
          // `Promise.prototype.catch` method
          // https://tc39.github.io/ecma262/#sec-promise.prototype.catch
          'catch': function (onRejected) {
            return this.then(undefined, onRejected);
          }
        });
        OwnPromiseCapability = function () {
          var promise = new Internal();
          var state = getInternalState(promise);
          this.promise = promise;
          this.resolve = bind(internalResolve, promise, state);
          this.reject = bind(internalReject, promise, state);
        };
        newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
          return C === PromiseConstructor || C === PromiseWrapper
            ? new OwnPromiseCapability(C)
            : newGenericPromiseCapability(C);
        };
      
        // wrap fetch result
        if (!IS_PURE && typeof $fetch == 'function') $({ global: true, enumerable: true, forced: true }, {
          // eslint-disable-next-line no-unused-vars
          fetch: function fetch(input) {
            return promiseResolve(PromiseConstructor, $fetch.apply(global, arguments));
          }
        });
      }
      
      $({ global: true, wrap: true, forced: FORCED }, {
        Promise: PromiseConstructor
      });
      
      setToStringTag(PromiseConstructor, PROMISE, false, true);
      setSpecies(PROMISE);
      
      PromiseWrapper = path[PROMISE];
      
      // statics
      $({ target: PROMISE, stat: true, forced: FORCED }, {
        // `Promise.reject` method
        // https://tc39.github.io/ecma262/#sec-promise.reject
        reject: function reject(r) {
          var capability = newPromiseCapability(this);
          capability.reject.call(undefined, r);
          return capability.promise;
        }
      });
      
      $({ target: PROMISE, stat: true, forced: IS_PURE || FORCED }, {
        // `Promise.resolve` method
        // https://tc39.github.io/ecma262/#sec-promise.resolve
        resolve: function resolve(x) {
          return promiseResolve(IS_PURE && this === PromiseWrapper ? PromiseConstructor : this, x);
        }
      });
      
      $({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION }, {
        // `Promise.all` method
        // https://tc39.github.io/ecma262/#sec-promise.all
        all: function all(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var resolve = capability.resolve;
          var reject = capability.reject;
          var result = perform(function () {
            var $promiseResolve = aFunction(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            iterate(iterable, function (promise) {
              var index = counter++;
              var alreadyCalled = false;
              values.push(undefined);
              remaining++;
              $promiseResolve.call(C, promise).then(function (value) {
                if (alreadyCalled) return;
                alreadyCalled = true;
                values[index] = value;
                --remaining || resolve(values);
              }, reject);
            });
            --remaining || resolve(values);
          });
          if (result.error) reject(result.value);
          return capability.promise;
        },
        // `Promise.race` method
        // https://tc39.github.io/ecma262/#sec-promise.race
        race: function race(iterable) {
          var C = this;
          var capability = newPromiseCapability(C);
          var reject = capability.reject;
          var result = perform(function () {
            var $promiseResolve = aFunction(C.resolve);
            iterate(iterable, function (promise) {
              $promiseResolve.call(C, promise).then(capability.resolve, reject);
            });
          });
          if (result.error) reject(result.value);
          return capability.promise;
        }
      });
      
      
      /***/ }),
      /* 78 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var redefine = __webpack_require__(44);
      
      module.exports = function (target, src, options) {
        for (var key in src) {
          if (options && options.unsafe && target[key]) target[key] = src[key];
          else redefine(target, key, src[key], options);
        } return target;
      };
      
      
      /***/ }),
      /* 79 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var getBuiltIn = __webpack_require__(12);
      var definePropertyModule = __webpack_require__(14);
      var wellKnownSymbol = __webpack_require__(1);
      var DESCRIPTORS = __webpack_require__(8);
      
      var SPECIES = wellKnownSymbol('species');
      
      module.exports = function (CONSTRUCTOR_NAME) {
        var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
        var defineProperty = definePropertyModule.f;
      
        if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
          defineProperty(Constructor, SPECIES, {
            configurable: true,
            get: function () { return this; }
          });
        }
      };
      
      
      /***/ }),
      /* 80 */
      /***/ (function(module, exports) {
      
      module.exports = function (it, Constructor, name) {
        if (!(it instanceof Constructor)) {
          throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
        } return it;
      };
      
      
      /***/ }),
      /* 81 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var wellKnownSymbol = __webpack_require__(1);
      var Iterators = __webpack_require__(10);
      
      var ITERATOR = wellKnownSymbol('iterator');
      var ArrayPrototype = Array.prototype;
      
      // check on default Array iterator
      module.exports = function (it) {
        return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
      };
      
      
      /***/ }),
      /* 82 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var classof = __webpack_require__(42);
      var Iterators = __webpack_require__(10);
      var wellKnownSymbol = __webpack_require__(1);
      
      var ITERATOR = wellKnownSymbol('iterator');
      
      module.exports = function (it) {
        if (it != undefined) return it[ITERATOR]
          || it['@@iterator']
          || Iterators[classof(it)];
      };
      
      
      /***/ }),
      /* 83 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var anObject = __webpack_require__(3);
      
      // call something on iterator step with safe closing on error
      module.exports = function (iterator, fn, value, ENTRIES) {
        try {
          return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
        // 7.4.6 IteratorClose(iterator, completion)
        } catch (error) {
          var returnMethod = iterator['return'];
          if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
          throw error;
        }
      };
      
      
      /***/ }),
      /* 84 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var wellKnownSymbol = __webpack_require__(1);
      
      var ITERATOR = wellKnownSymbol('iterator');
      var SAFE_CLOSING = false;
      
      try {
        var called = 0;
        var iteratorWithReturn = {
          next: function () {
            return { done: !!called++ };
          },
          'return': function () {
            SAFE_CLOSING = true;
          }
        };
        iteratorWithReturn[ITERATOR] = function () {
          return this;
        };
        // eslint-disable-next-line no-throw-literal
        Array.from(iteratorWithReturn, function () { throw 2; });
      } catch (error) { /* empty */ }
      
      module.exports = function (exec, SKIP_CLOSING) {
        if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
        var ITERATION_SUPPORT = false;
        try {
          var object = {};
          object[ITERATOR] = function () {
            return {
              next: function () {
                return { done: ITERATION_SUPPORT = true };
              }
            };
          };
          exec(object);
        } catch (error) { /* empty */ }
        return ITERATION_SUPPORT;
      };
      
      
      /***/ }),
      /* 85 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var global = __webpack_require__(0);
      var getOwnPropertyDescriptor = __webpack_require__(35).f;
      var classof = __webpack_require__(11);
      var macrotask = __webpack_require__(46).set;
      var userAgent = __webpack_require__(47);
      
      var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
      var process = global.process;
      var Promise = global.Promise;
      var IS_NODE = classof(process) == 'process';
      // Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
      var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
      var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
      
      var flush, head, last, notify, toggle, node, promise;
      
      // modern engines have queueMicrotask method
      if (!queueMicrotask) {
        flush = function () {
          var parent, fn;
          if (IS_NODE && (parent = process.domain)) parent.exit();
          while (head) {
            fn = head.fn;
            head = head.next;
            try {
              fn();
            } catch (error) {
              if (head) notify();
              else last = undefined;
              throw error;
            }
          } last = undefined;
          if (parent) parent.enter();
        };
      
        // Node.js
        if (IS_NODE) {
          notify = function () {
            process.nextTick(flush);
          };
        // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
        } else if (MutationObserver && !/(iphone|ipod|ipad).*applewebkit/i.test(userAgent)) {
          toggle = true;
          node = document.createTextNode('');
          new MutationObserver(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
          notify = function () {
            node.data = toggle = !toggle;
          };
        // environments with maybe non-completely correct, but existent Promise
        } else if (Promise && Promise.resolve) {
          // Promise.resolve without an argument throws an error in LG WebOS 2
          promise = Promise.resolve(undefined);
          notify = function () {
            promise.then(flush);
          };
        // for other environments - macrotask based on:
        // - setImmediate
        // - MessageChannel
        // - window.postMessag
        // - onreadystatechange
        // - setTimeout
        } else {
          notify = function () {
            // strange IE + webpack dev server bug - use .call(global)
            macrotask.call(global, flush);
          };
        }
      }
      
      module.exports = queueMicrotask || function (fn) {
        var task = { fn: fn, next: undefined };
        if (last) last.next = task;
        if (!head) {
          head = task;
          notify();
        } last = task;
      };
      
      
      /***/ }),
      /* 86 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var global = __webpack_require__(0);
      
      module.exports = function (a, b) {
        var console = global.console;
        if (console && console.error) {
          arguments.length === 1 ? console.error(a) : console.error(a, b);
        }
      };
      
      
      /***/ }),
      /* 87 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var $ = __webpack_require__(7);
      var getBuiltIn = __webpack_require__(12);
      var speciesConstructor = __webpack_require__(45);
      var promiseResolve = __webpack_require__(48);
      
      // `Promise.prototype.finally` method
      // https://tc39.github.io/ecma262/#sec-promise.prototype.finally
      $({ target: 'Promise', proto: true, real: true }, {
        'finally': function (onFinally) {
          var C = speciesConstructor(this, getBuiltIn('Promise'));
          var isFunction = typeof onFinally == 'function';
          return this.then(
            isFunction ? function (x) {
              return promiseResolve(C, onFinally()).then(function () { return x; });
            } : onFinally,
            isFunction ? function (e) {
              return promiseResolve(C, onFinally()).then(function () { throw e; });
            } : onFinally
          );
        }
      });
      
      
      /***/ }),
      /* 88 */
      /***/ (function(module, exports, __webpack_require__) {
      
      var $ = __webpack_require__(7);
      var getPrototypeOf = __webpack_require__(29);
      var setPrototypeOf = __webpack_require__(43);
      var create = __webpack_require__(38);
      var createPropertyDescriptor = __webpack_require__(15);
      var iterate = __webpack_require__(19);
      var hide = __webpack_require__(2);
      
      var $AggregateError = function AggregateError(errors, message) {
        var that = this;
        if (!(that instanceof $AggregateError)) return new $AggregateError(errors, message);
        if (setPrototypeOf) {
          that = setPrototypeOf(new Error(message), getPrototypeOf(that));
        }
        var errorsArray = [];
        iterate(errors, errorsArray.push, errorsArray);
        that.errors = errorsArray;
        if (message !== undefined) hide(that, 'message', String(message));
        return that;
      };
      
      $AggregateError.prototype = create(Error.prototype, {
        constructor: createPropertyDescriptor(5, $AggregateError),
        name: createPropertyDescriptor(5, 'AggregateError')
      });
      
      $({ global: true }, {
        AggregateError: $AggregateError
      });
      
      
      /***/ }),
      /* 89 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var $ = __webpack_require__(7);
      var aFunction = __webpack_require__(9);
      var newPromiseCapabilityModule = __webpack_require__(13);
      var perform = __webpack_require__(20);
      var iterate = __webpack_require__(19);
      
      // `Promise.allSettled` method
      // https://github.com/tc39/proposal-promise-allSettled
      $({ target: 'Promise', stat: true }, {
        allSettled: function allSettled(iterable) {
          var C = this;
          var capability = newPromiseCapabilityModule.f(C);
          var resolve = capability.resolve;
          var reject = capability.reject;
          var result = perform(function () {
            var promiseResolve = aFunction(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            iterate(iterable, function (promise) {
              var index = counter++;
              var alreadyCalled = false;
              values.push(undefined);
              remaining++;
              promiseResolve.call(C, promise).then(function (value) {
                if (alreadyCalled) return;
                alreadyCalled = true;
                values[index] = { status: 'fulfilled', value: value };
                --remaining || resolve(values);
              }, function (e) {
                if (alreadyCalled) return;
                alreadyCalled = true;
                values[index] = { status: 'rejected', reason: e };
                --remaining || resolve(values);
              });
            });
            --remaining || resolve(values);
          });
          if (result.error) reject(result.value);
          return capability.promise;
        }
      });
      
      
      /***/ }),
      /* 90 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var $ = __webpack_require__(7);
      var newPromiseCapabilityModule = __webpack_require__(13);
      var perform = __webpack_require__(20);
      
      // `Promise.try` method
      // https://github.com/tc39/proposal-promise-try
      $({ target: 'Promise', stat: true }, {
        'try': function (callbackfn) {
          var promiseCapability = newPromiseCapabilityModule.f(this);
          var result = perform(callbackfn);
          (result.error ? promiseCapability.reject : promiseCapability.resolve)(result.value);
          return promiseCapability.promise;
        }
      });
      
      
      /***/ }),
      /* 91 */
      /***/ (function(module, exports, __webpack_require__) {
      
      "use strict";
      
      var $ = __webpack_require__(7);
      var aFunction = __webpack_require__(9);
      var getBuiltIn = __webpack_require__(12);
      var newPromiseCapabilityModule = __webpack_require__(13);
      var perform = __webpack_require__(20);
      var iterate = __webpack_require__(19);
      
      var PROMISE_ANY_ERROR = 'No one promise resolved';
      
      // `Promise.any` method
      // https://github.com/tc39/proposal-promise-any
      $({ target: 'Promise', stat: true }, {
        any: function any(iterable) {
          var C = this;
          var capability = newPromiseCapabilityModule.f(C);
          var resolve = capability.resolve;
          var reject = capability.reject;
          var result = perform(function () {
            var promiseResolve = aFunction(C.resolve);
            var errors = [];
            var counter = 0;
            var remaining = 1;
            var alreadyResolved = false;
            iterate(iterable, function (promise) {
              var index = counter++;
              var alreadyRejected = false;
              errors.push(undefined);
              remaining++;
              promiseResolve.call(C, promise).then(function (value) {
                if (alreadyRejected || alreadyResolved) return;
                alreadyResolved = true;
                resolve(value);
              }, function (e) {
                if (alreadyRejected || alreadyResolved) return;
                alreadyRejected = true;
                errors[index] = e;
                --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
              });
            });
            --remaining || reject(new (getBuiltIn('AggregateError'))(errors, PROMISE_ANY_ERROR));
          });
          if (result.error) reject(result.value);
          return capability.promise;
        }
      });
      
      
      /***/ })
      /******/ ]);